import { Trans } from "@lingui/react/macro";
import React from "react";
import { TextStyle, TextStyleProps } from "@silversea-ssc/ui-components-react";

type Props = {
  textAlign: TextStyleProps["textAlign"];
  titleFontSize: TextStyleProps["fontSize"];
  contentFontSize: TextStyleProps["fontSize"];
};

const SendQuoteSectionIntroText: React.FC<Props> = ({
  textAlign,
  titleFontSize = "medium",
  contentFontSize = "small"
}) => (
  <TextStyle fontSize={titleFontSize} textAlign={textAlign}>
    <Trans id="quote-submit-disclaimer-title">
      By submitting this form you will receive via email your quote and detailed
      booking policy.
    </Trans>
    <TextStyle fontSize={contentFontSize}>
      <Trans id="quote-submit-disclaimer-content">
        One of our personal cruise consultants will contact you in the next few
        days to answer all your questions regarding your voyage and finalize
        your booking.
      </Trans>
    </TextStyle>
  </TextStyle>
);
export default SendQuoteSectionIntroText;
